import * as types from './actionTypes';  
import setUnderwriterApi from '../api/setUnderwriterApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doSetUnderwriter(request) {

  return {
    type: types.DO_SET_UNDERWRITER, 
    request
  };
}

export function doSetUnderwriterRes(data) {  
  return {
    type: types.DO_SET_UNDERWRITER_RES, 
    data
  };
}

export function setUnderwriters(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      setUnderwriterApi.doSetUnderwriter(request).then(data => {
        dispatch(doSetUnderwriterRes(data));
        dispatch(doSetUnderwriterRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}